import { MessageCircle, Phone } from "lucide-react";
import { NAV_LINKS, SITE } from "../../data/content";
import { scrollToId } from "../../lib/scroll";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer className="bg-deep text-paper">
    <div className="mx-auto max-w-7xl px-6 py-20">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-8 border-b border-paper/10 pb-12">
          <div>
            <p className="font-arabic text-3xl text-paper/50">مؤسسة لندن إمبريال</p>
            <p className="mt-3 font-serif text-4xl tracking-tight md:text-6xl">
              London Empire Institution
            </p>
          </div>
          <p className="max-w-xs text-sm leading-relaxed text-paper/60">
            Native Arabic tuition in Modern Standard, Levantine, Gulf and Egyptian — at Wembley
            Park, London, or online.
          </p>
        </div>
      </Reveal>

      <div className="grid gap-10 py-12 sm:grid-cols-3">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold">Visit</p>
          <p className="mt-4 text-sm leading-relaxed text-paper/70" data-testid="footer-address">
            {SITE.addressFull}
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold">Contact</p>
          <div className="mt-4 space-y-2 text-sm">
            <a
              href={`tel:${SITE.phoneTel}`}
              className="flex items-center gap-2 text-paper/70 transition-colors duration-200 hover:text-paper"
            >
              <Phone className="h-3.5 w-3.5" /> {SITE.phoneDisplay}
            </a>
            <a
              href={`mailto:${SITE.email}`}
              className="block break-all text-paper/70 transition-colors duration-200 hover:text-paper"
            >
              {SITE.email}
            </a>
            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-paper/70 transition-colors duration-200 hover:text-paper"
            >
              <MessageCircle className="h-3.5 w-3.5" /> WhatsApp chat
            </a>
          </div>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold">Explore</p>
          <div className="mt-4 flex flex-col items-start gap-2 text-sm">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToId(l.id)}
                className="text-paper/70 transition-colors duration-200 hover:text-paper"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-4 border-t border-paper/10 pt-8 text-xs text-paper/40">
        <p>© {new Date().getFullYear()} London Empire Institution. All rights reserved.</p>
        <p>Cancellation with 48 hours&apos; notice · Lessons 90 minutes to 2 hours</p>
      </div>
    </div>
  </footer>
);

export default Footer;
